import { render, staticRenderFns } from "./soMeLoginButtons.vue?vue&type=template&id=d1988e36"
import script from "./soMeLoginButtons.vue?vue&type=script&lang=js"
export * from "./soMeLoginButtons.vue?vue&type=script&lang=js"
import style0 from "./soMeLoginButtons.vue?vue&type=style&index=0&id=d1988e36&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/social-login-buttons/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1988e36')) {
      api.createRecord('d1988e36', component.options)
    } else {
      api.reload('d1988e36', component.options)
    }
    module.hot.accept("./soMeLoginButtons.vue?vue&type=template&id=d1988e36", function () {
      api.rerender('d1988e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/soMeLoginButtons.vue"
export default component.exports